import type { TFunction } from 'i18next';
import type { JSX } from 'react';
import React from 'react';

import type { IColumn } from '@feathr/components';
import { ProgressBar, Text } from '@feathr/components';

import { goalTypeLabel, type IGoalRow } from './ConversionsByGoalTable.utils';

import * as styles from './ConversionsByGoalTable.css';

const INTEGER = new Intl.NumberFormat('en-US');

interface IBuildColumnsArgs {
  t: TFunction;
}

export function buildGoalColumns({ t }: IBuildColumnsArgs): Array<IColumn<IGoalRow>> {
  return [
    {
      id: 'name',
      Header: t('Goal'),
      accessor: 'name',
      Cell({ original }: { original: IGoalRow }): JSX.Element {
        return <Text.DefaultRegular>{original.name}</Text.DefaultRegular>;
      },
    },
    {
      id: 'type',
      Header: t('Type'),
      accessor: 'type',
      Cell({ original }: { original: IGoalRow }): JSX.Element {
        return <Text.DefaultRegular>{goalTypeLabel(t, original.type)}</Text.DefaultRegular>;
      },
    },
    {
      id: 'numConversions',
      Header: t('Conversions'),
      accessor: 'numConversions',
      Cell({ original }: { original: IGoalRow }): JSX.Element {
        return <Text.DefaultRegular>{INTEGER.format(original.numConversions)}</Text.DefaultRegular>;
      },
    },
    {
      id: 'sharePercent',
      Header: t('Share'),
      accessor: 'sharePercent',
      Cell({ original }: { original: IGoalRow }): JSX.Element {
        return (
          <div className={styles.shareCell}>
            <ProgressBar value={original.sharePercent} />
            <Text.DefaultRegular>{`${original.sharePercent}%`}</Text.DefaultRegular>
          </div>
        );
      },
    },
  ];
}
